/* src/app/main-layout/header/header.component.css */
@layer properties;
.logo {
  display: flex;
  max-width: calc(var(--spacing, 0.25rem) * 28);
  align-items: center;
  justify-content: center;
}
.logo-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-img {
  height: auto;
  width: 35%;
}
.logo-img-sk {
  height: 100%;
  width: 100%;
}
.header {
  position: fixed;
  top: calc(var(--spacing, 0.25rem) * 0);
  left: calc(var(--spacing, 0.25rem) * 0);
  z-index: 1100;
  height: calc(var(--spacing, 0.25rem) * 16);
  width: 100%;
  background-color: var(--color-white, #fff);
  --tw-shadow: 0 4px 10px 0 var(--tw-shadow-color, rgb(0 0 0/25%));
  box-shadow:
    var(--tw-inset-shadow),
    var(--tw-inset-ring-shadow),
    var(--tw-ring-offset-shadow),
    var(--tw-ring-shadow),
    var(--tw-shadow);
}
.header-row {
  display: flex;
  height: 100%;
  align-items: center;
}
.header-actions {
  margin-inline-start: calc(var(--spacing, 0.25rem) * 1);
  display: none;
  flex-direction: row;
  gap: calc(var(--spacing, 0.25rem) * 2.5);
  align-self: center;
}
@media (width >= 40rem) {
  .header-actions {
    display: flex;
  }
}
@media (width >= 64rem) {
  .header-actions {
    margin-inline-start: calc(var(--spacing, 0.25rem) * 14);
  }
}
.header-tools {
  margin-inline-start: auto;
  display: flex;
  align-items: center;
  padding-inline-end: calc(var(--spacing, 0.25rem) * 6);
}
.invoice-warning {
  margin-inline-end: calc(var(--spacing, 0.25rem) * 6);
  display: none;
  --tw-font-weight: var(--font-weight-medium, 500);
  font-weight: var(--font-weight-medium, 500);
  color: var(--color-white, #fff);
}
@media (width >= 64rem) {
  .invoice-warning {
    display: block;
  }
}
.invoice-warning-mobile {
  margin-inline-end: calc(var(--spacing, 0.25rem) * 2.5);
  color: var(--color-danger, #da0d0d);
}
@media (width >= 40rem) {
  .invoice-warning-mobile {
    margin-inline-end: calc(var(--spacing, 0.25rem) * 6);
  }
}
@media (width >= 64rem) {
  .invoice-warning-mobile {
    display: none;
  }
}
.invoice-warning-icon {
  cursor: pointer;
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  color: var(--color-white, #fff);
}
.material {
  margin-inline-end: calc(var(--spacing, 0.25rem) * 2.5);
}
@media (width >= 40rem) {
  .material {
    margin-inline-end: calc(var(--spacing, 0.25rem) * 11);
  }
}
.user {
  margin-inline-end: calc(var(--spacing, 0.25rem) * 3.5);
}
@media (width >= 40rem) {
  .user {
    margin-inline-end: calc(var(--spacing, 0.25rem) * 6);
  }
}
.cog {
  margin-inline-end: calc(var(--spacing, 0.25rem) * 3.5);
}
@media (width >= 40rem) {
  .cog {
    margin-inline-end: calc(var(--spacing, 0.25rem) * 6);
  }
}
.tools-list {
  display: flex;
  list-style-type: none;
  align-items: center;
}
@property --tw-shadow { syntax: "*"; inherits: false; initial-value: 0 0 #0000; }
@property --tw-shadow-color { syntax: "*"; inherits: false; }
@property --tw-shadow-alpha { syntax: "<percentage>"; inherits: false; initial-value: 100%; }
@property --tw-inset-shadow { syntax: "*"; inherits: false; initial-value: 0 0 #0000; }
@property --tw-inset-shadow-color { syntax: "*"; inherits: false; }
@property --tw-inset-shadow-alpha { syntax: "<percentage>"; inherits: false; initial-value: 100%; }
@property --tw-ring-color { syntax: "*"; inherits: false; }
@property --tw-ring-shadow { syntax: "*"; inherits: false; initial-value: 0 0 #0000; }
@property --tw-inset-ring-color { syntax: "*"; inherits: false; }
@property --tw-inset-ring-shadow { syntax: "*"; inherits: false; initial-value: 0 0 #0000; }
@property --tw-ring-inset { syntax: "*"; inherits: false; }
@property --tw-ring-offset-width { syntax: "<length>"; inherits: false; initial-value: 0px; }
@property --tw-ring-offset-color { syntax: "*"; inherits: false; initial-value: #fff; }
@property --tw-ring-offset-shadow { syntax: "*"; inherits: false; initial-value: 0 0 #0000; }
@property --tw-font-weight { syntax: "*"; inherits: false; }
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *,
    ::before,
    ::after,
    ::backdrop {
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-font-weight: initial;
    }
  }
}
/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
/*# sourceMappingURL=header.component.css.map */
